import { render, staticRenderFns } from "./TradesPickerModal.vue?vue&type=template&id=04210fb9"
import script from "./TradesPickerModal.vue?vue&type=script&lang=js"
export * from "./TradesPickerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports